import { ReapplyBlockedReason } from "~/gql/graphqlBase.generated";
import {
	type GetReapplyRecipesPreviewQuery,
	type ReapplyErrorFieldsFragment
} from "~/gql/queries/produce/reapplyRecipes.generated";

type Preview = GetReapplyRecipesPreviewQuery["reapplyRecipesPreview"][number];
type ReapplyEligibility = Pick<Preview, "blockedReason" | "recipeDeleted">;

export const REAPPLY_JOB_NOT_ACTIVE = "JOB_NOT_ACTIVE";

const BLOCKED_REASON_LABEL_KEYS: Record<ReapplyBlockedReason, string> = {
	[ReapplyBlockedReason.JobPosted]: "schedule.reapplyRecipes.blocked.jobPosted",
	[ReapplyBlockedReason.JobStarted]: "schedule.reapplyRecipes.blocked.jobStarted",
	[ReapplyBlockedReason.LotNotActive]: "schedule.reapplyRecipes.blocked.lotNotActive"
};

const blockedReasonLabelKey = (reason: ReapplyBlockedReason): string => BLOCKED_REASON_LABEL_KEYS[reason];

export const isPreviewReapplicable = (preview: ReapplyEligibility): boolean =>
	!preview.recipeDeleted && !preview.blockedReason;

export const areAllJobsBlocked = (previews: ReapplyEligibility[]): boolean =>
	previews.some((preview) => preview.blockedReason) && !previews.some(isPreviewReapplicable);

export const findBlockedChildReason = (
	previews: Iterable<Pick<Preview, "affectedChildJobs">>,
	childJobId: string
): ReapplyBlockedReason | null => {
	for (const preview of previews) {
		const child = preview.affectedChildJobs.find((candidate) => candidate.productionJobId === childJobId);
		if (child) return child.blockedReason ?? null;
	}
	return null;
};

export const isJobNotActiveError = (error: Pick<ReapplyErrorFieldsFragment, "code">): boolean =>
	error.code === REAPPLY_JOB_NOT_ACTIVE;

export default blockedReasonLabelKey;
